import { useState } from 'react';
import Fileupload from '../../components/Fileupload';
import { IconButton, FilledButton } from '@sainsburys-tech/luna-button';
import { Download } from '@sainsburys-tech/luna-icons';
import style from './style.module.css';
import ProgressIndicator from '../../components/ProgressIndicator'
import { acquireToken } from "../../authConfig";
import { trackError } from "../../appinsights/applogs";
import { Table } from '@sainsburys-tech/luna-table';
import ExcelJS from 'exceljs';


const Budget = () => {

    const [budgetData, setBudgetData] = useState([]);
    const [erroMessage, setErrorText] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    //const [isMissingFile, setFileUpload] = useState(false);
    const [budgetsavemsg, setbudgetsavemsg] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [showRemarks, setShowRemarks] = useState(false);

    let displayColumns = [
        {
            name: 'EventId',
            accessor: rowData => ({ value: rowData.LeaseEvents_ID }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'BudgetRent',
            accessor: rowData => ({
                value: rowData.BudgetRent ?
                    (!isNaN(rowData.BudgetRent) ?
                        Number(rowData.BudgetRent).toFixed(2) : rowData.BudgetRent)
                    : rowData.BudgetRent
            }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'Agency',
            accessor: rowData => ({ value: rowData.Agency }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'Comment',
            accessor: rowData => ({ value: rowData.Comment }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'PropertyName',
            accessor: rowData => ({ value: rowData.PropertyName }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'PropertySubType',
            accessor: rowData => ({ value: rowData.PropertySubType }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'PropertyType',
            accessor: rowData => ({ value: rowData.PropertyType }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'ReviewDate',
            accessor: rowData => ({ value: rowData.ReviewDate ? new Date(rowData.ReviewDate).toLocaleDateString() : '' }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'StoreNumber',
            accessor: rowData => ({ value: rowData.StoreNumber }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'SSLManager',
            accessor: rowData => ({ value: rowData.SSLManager }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'LeaseRef',
            accessor: rowData => ({ value: rowData.LeaseRef }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'LeaseStartDate',
            accessor: rowData => ({ value: rowData.LeaseStartDate ? new Date(rowData.LeaseStartDate).toLocaleDateString() : '' }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'LeaseEndDate',
            accessor: rowData => ({ value: rowData.LeaseEndDate ? new Date(rowData.LeaseEndDate).toLocaleDateString() : '' }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'EventType',
            accessor: rowData => ({ value: rowData.EventType }),
            hideLabel: true,
            className: 'customCol',
        },
        {
            name: 'EventStatus',
            accessor: rowData => ({ value: rowData.EventStatus }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'PassingRent',
            accessor: rowData => ({ value: rowData.PassingRent }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'BudgetStatus',
            accessor: rowData => ({ value: rowData.BudgetStatus }),
            hideLabel: false,
            className: 'customCol',
        },
        {
            name: 'Remarks',
            accessor: rowData => ({ value: rowData.Remarks }),
            hideLabel: true,
            className: 'customCol',
        }
    ];

    displayColumns = showRemarks ? displayColumns.filter((c) => c.hideLabel === true) : displayColumns.filter((c) => c.name !== 'Remarks');

    const handleSubmission = () => {
        if (selectedFile == null) {
            setErrorText("Please select the Budget Details Template for upload.");
        }

        else {
            const formData = new FormData();
            if (selectedFile) {
                formData.append('formFile', selectedFile);
                setFileLoading(true);
                acquireToken().then((response) => {
                    
                    var res = fetch(window.location.origin + '/api/file/BudgetUpload', {
                        method: 'POST',
                        headers: { Authorization: 'Bearer ' + response.accessToken },
                        body: formData,
                    });

                    res.then(response => response.json())
                        .then(data => {
                            if (typeof data === 'string') {
                                setErrorText(data);
                                setBudgetData([]);
                            }
                            else {
                                setErrorText('');
                                setShowRemarks(false);
                                setBudgetData(data);
                            }
                            setFileLoading(false);
                        })
                        .catch((error) => {
                            setFileLoading(false);
                            console.error('Error:', error);
                            trackError(error);
                        });
                });
            }
        }
    };

    const saveBudget = (e) => {

        if (selectedFile == null) {
            setErrorText("Please select the Budget Details Template for upload.");
        }

        else {
            //if (budgetData.length > 0) {
            //    setFileLoading(true);
            //    setbudgetsavemsg(true);
            //    setTimeout(function () {
            //        setbudgetsavemsg(false);
            //        setBudgetData([]);
            //    }, 3000);
            //    setFileLoading(false);
            //}

            const formData = new FormData();
            if (selectedFile && budgetData.length > 0) {
                formData.append('formFile', selectedFile);
                setFileLoading(true);
                acquireToken().then((response) => {

                    var res = fetch(window.location.origin + '/api/file/SaveBudgetDetails', {
                        method: 'POST',
                        headers: { Authorization: 'Bearer ' + response.accessToken },
                        body: formData,
                    });

                    res.then(response => response.json())
                        .then(data => {
                            if (typeof data === 'string') {
                                setErrorText(data);
                                setBudgetData([]);
                            }
                            else {
                                setErrorText('');
                                setShowRemarks(true);
                                setBudgetData(data);
                                setFileLoading(false);
                                setbudgetsavemsg(true);
                                setTimeout(function () {
                                    setbudgetsavemsg(false);
                                }, 3000);
                            }
                        })
                        .catch((error) => {
                            setFileLoading(false);
                            console.error('Error:', error);
                            trackError(error);
                        });
                });
            }
        }
    }

    const changeHandler = (event) => {
        setSelectedFile(null);
        const file = event.target.files[0];

        if (file !== null && file !== undefined) {
            const ext = file.name.split('.').pop();

            if (ext === "xlsx") {
                setSelectedFile(file);
                //setIsFileSelected(true);
                setErrorText("");
            } else {
                event.preventDefault();
                event.target.value = "";
                setErrorText("Invalid file type selected for Budget upload, please select xlsx file");
            }
        }
    };

    const exportBudgetToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Lease Event Budget');

        // Define columns
        worksheet.columns = [
            { header: 'LeaseEvents_ID', key: 'LeaseEvents_ID', width: 15 },
            { header: 'Store Number', key: 'StoreNumber', width: 12 },
            { header: 'Property Name', key: 'PropertyName', width: 20 },
            { header: 'Property Type', key: 'PropertyType', width: 15 },
            { header: 'Property Sub Type', key: 'PropertySubType', width: 18 },
            { header: 'Lease Ref', key: 'LeaseRef', width: 12 },
            { header: 'Lease Desc / Tenant', key: 'LeaseDescTenant', width: 20 },
            { header: 'Event Type', key: 'EventType', width: 12 },
            { header: 'Review Date', key: 'ReviewDate', width: 12 },
            { header: 'Passing Rent', key: 'PassingRent', width: 12 },
            { header: 'SSL Manager', key: 'SSLManager', width: 15 },
            { header: 'Property Event Type', key: 'PropertyEventType', width: 18 },
            { header: 'Event Status', key: 'EventStatus', width: 12 },
            { header: 'Budget Status', key: 'BudgetStatus', width: 12 },
            { header: 'Landlord Name', key: 'LandlordName', width: 15 },
            { header: 'Lease Start Date', key: 'LeaseStartDate', width: 14 },
            { header: 'Lease End Date', key: 'LeaseEndDate', width: 14 },
            { header: 'Agency', key: 'Agency', width: 12 },
            { header: 'Budget Rent', key: 'BudgetRent', width: 12 },
            { header: 'Comment', key: 'Comment', width: 25 },
            { header: 'Remarks', key: 'Remarks', width: 25 }
        ];

        // Add rows
        budgetData.forEach(item => {
            worksheet.addRow({
                LeaseEvents_ID: item.LeaseEvents_ID,
                StoreNumber: item.StoreNumber,
                PropertyName: item.PropertyName,
                PropertyType: item.PropertyType,
                PropertySubType: item.PropertySubType,
                LeaseRef: item.LeaseRef,
                LeaseDescTenant: item['LeaseDesc/Tenant'],
                EventType: item.EventType,
                ReviewDate: item.ReviewDate ? new Date(item.ReviewDate) : null,
                PassingRent: item.PassingRent,
                SSLManager: item.SSLManager,
                PropertyEventType: item.PropertyEventType,
                EventStatus: item.EventStatus,
                BudgetStatus: item.BudgetStatus,
                LandlordName: item.LandlordName,
                LeaseStartDate: item.LeaseStartDate ? new Date(item.LeaseStartDate) : null,
                LeaseEndDate: item.LeaseEndDate ? new Date(item.LeaseEndDate) : null,
                Agency: item.Agency,
                BudgetRent: item.BudgetRent || null,
                Comment: item.Comment,
                Remarks: item.Remarks
            });
        });

        // Style header row
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFD3D3D3' }
        };

        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `lease-events-budget-${new Date().toLocaleString()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: '10px' }}>
            <h3 style={{ marginBottom: '0px' }}>Budget Import</h3>
            <div style={{ paddingLeft: '10px' }}>
                {erroMessage ? <div className={style.rralert}>{erroMessage}</div> : ''}
                {budgetsavemsg ? <div className={style.rrsuccessalert}> The Budget details updated successfully, View remarks for individual event success/failed. </div> : ""}
                <Fileupload onClick={() => handleSubmission()} onChange={changeHandler} acceptExtension=".xlsx" name="Budget Upload" />
                <FilledButton style={{ marginRight: '5px' }} onClick={() => saveBudget()} >Save Budget</FilledButton>
                {showRemarks ? <IconButton
                    name='budgetExportBtn'
                    variant='outlined'
                    label='Result Export'
                    style={{ float: 'right', marginTop: '5px' }}
                    onClick={() => exportBudgetToExcel()}
                >
                    <Download />
                </IconButton> : <></>
                }
                <br /><br />
                {budgetData.length > 0 ?
                    <div style={{ maxHeight: '375px', overflowY: 'scroll' }}>
                        <Table
                            rowKey="LeaseEvents_ID"
                            sortable
                            data={budgetData}
                            columns={displayColumns}
                        /> </div>
                    : <></>}
            </div>
            {fileLoading ?
                <ProgressIndicator />
                : <></>
            }
        </div>
    );
};

export default Budget;
